import { render, staticRenderFns } from "./UserInvoice.vue?vue&type=template&id=028c1305&scoped=true&"
import script from "./UserInvoice.vue?vue&type=script&lang=js&"
export * from "./UserInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028c1305",
  null
  
)

export default component.exports